import groupMembershipActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

const fetchGroupMembershipOptions = {
  asyncReducers: {
    success: (state: any, action: any) => {
      return {
        ...state,
        groupMemberships: {
          ...state.groupMemberships,
          [action.groupId]: action.response.items,
        },
      };
    },
  },
};

export const reducers = {
  fetchGroupMembership: createAsyncRequestReducer(
    groupMembershipActionTypes.FETCH_GROUP_MEMBERSHIP,
    fetchGroupMembershipOptions,
  ),
  removeGroupMembership: createAsyncRequestReducer(
    groupMembershipActionTypes.REMOVE_GROUP_MEMBERSHIP,
  ),
};

export default combineReducers(reducers);
